import { REDUX_ACTIONS, GAME_ID } from 'a/storybox/data/constants';

const initialState = 0;

const gameDetailsReducer = (state = initialState, { gameId, payload, type }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return payload.index;

    default:
      return state;
  }
};

export default gameDetailsReducer;
